import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_wbbnx685aq: FaireBrandEntity = {
  token: "b_wbbnx685aq",
  type: "brand",
  name: "Gumdrop Garden",
  avatarUrl:
    "https://cdn.faire.com/fastly/d8f96a29f29d325b28d40ea6aa03cd030692bd86b4e2344eb19e2021a851b70f.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/a4727009c0d6029ac06841b504f7583e9ee60fc554c0c172ac1f720c879b383b.png",
  logoUrl:
    "https://cdn.faire.com/fastly/d8f96a29f29d325b28d40ea6aa03cd030692bd86b4e2344eb19e2021a851b70f.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/a4727009c0d6029ac06841b504f7583e9ee60fc554c0c172ac1f720c879b383b.png",
  location: "Massapequa , NY, USA",
  minimumOrderDollars: 150,
  rating: 4.4,
  reviewCount: 38,
  isInsider: true,
  description:
    "At Gumdrop Garden, we specialize in curating unique, high-quality confections that stand out on any shelf. From our playful, trending candy collections to our luxurious Dubai Luxe Chocolates — handcrafted in Dubai with rich Belgian chocolate and bold Middle Eastern flavors — every product we carry is chosen with creativity, quality, and customer delight in mind.\n\nWhether you’re looking for eye-catching novelty sweets, elevated chocolate bars, or unforgettable giftable treats, Gumdrop Garden delivers wholesale candy with personality and profit potential. We love helping retailers stock shelves with sweets that surprise, delight, and keep customers coming back.\n\n",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:58.007Z",
    importedBy: "entity-db-cli",
  },
};
